import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  borderRadius: 'md',
  contain: 'paint',
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
  mb: '3',
  border: '0',
  fontFamily: 'accent',
  ...(isNested && {
    boxShadow: 'unset',
    mb: '2',
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  border: 0,
  p: '3',
  borderBottomRadius: 'md',
  bg: 'rgb(114, 68, 238)',
  ...(isNested && {
    border: '1px',
    borderTop: 0,
    borderColor: 'blackAlpha.200',
    bg: 'rgb(104, 56, 236)',
    boxShadow:
      '0px 3px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'rgb(114, 68, 238)',
  color: 'gamma.200',
  px: '2',
  py: '2.5',
  borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'lg',
  fontWeight: 'normal',
  fontSize: 'sm',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  justifyContent: 'space-between',

  '.chakra-accordion__icon': {
    boxSize: '5',
    color: 'white',
    transition: '.3s ease-in-out',
  },

  _expanded: {
    p: '2',
    borderBottomRadius: 'none',
  },

  ...(isNested && {
    bg: 'rgb(104, 56, 236)',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    color: 'gamma.200',
    fontWeight: 'normal',
    px: '2',

    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      transition: '.3s ease-in-out',
    },
  }),
});

export const BoxWrapper: CSSObject = {
  py: '2',
  px: '0',
  borderBottomRadius: '6px',
};
